import React from 'react';
import Alert from '@material-ui/core/Alert';
import { Box } from '@material-ui/core'
import DominioDisponible from './DominioDisponible';
import DominioNoDisponible from './DominioNoDisponible';
import { useTranslation } from 'react-i18next';

function VerificarDominio(props) {
  const { t } = useTranslation();
  const status = props.domainstatus;
  const product = props.product;
  const billingcycle = props.billingcycle;
  const tld = props.tld;
  const eventDomain = props.eventDomain;
  const configproduct = props.configproduct;
  const coupon = props.coupon;
  const typeui = props.typeui;
  const curcode = props.curcode;

  if(eventDomain === 'domainregister'){
    if (status === 'available') {
      return <DominioDisponible dominio={props.inputdomain} product={product} billingcycle={billingcycle} tld={tld} eventDomain={eventDomain} configproduct={configproduct} coupon={coupon} typeui={typeui} curcode={curcode} />;
    }
    if (status === 'regthroughus' || status === 'regthroughothers' || status === 'unknown') {
      return <DominioNoDisponible dominio={props.inputdomain} eventDomain={eventDomain}/>;
    }
  }
  if(eventDomain === 'domaintransfer'){
    if(status === 'regthroughothers'){
      return <DominioDisponible dominio={props.inputdomain} product={product} billingcycle={billingcycle} tld={tld} eventDomain={eventDomain} configproduct={configproduct} coupon={coupon} typeui={typeui} curcode={curcode} />;
    }
    if(status === 'available' || status === 'regthroughus' || status === 'unknown'){
      return <DominioNoDisponible dominio={props.inputdomain} eventDomain={eventDomain}/>;
    }
  }
  
  return (
    <Box mt={3}>
      <Alert severity="info">{t('enterDomain')}</Alert>
    </Box>
  )


}

export default VerificarDominio;